/**
 * Created For: 药厂信息相关接口
 * Author: xuRui.
 * Date: 2018/11/30 0030 16:17.
 */
import request from '@/utils/request'

// 反馈
export function addFeedBack (data) {
  return request({
    url: '/v1/client-feedback/error_info',
    data,
    method: 'post'
  })
}

// 获取属于用户的药品信息
export function purchaseDetail (data) {
  return request({
    url: '/v1/adb/search/trading_company',
    data,
    method: 'post'
  })
}
